import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import axios from 'axios';
import { message } from '@/utils/message';
import store from '@/store';
import { getToken } from '@/utils/auth';
import define from '@/utils/define';

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: false,
  // send cookies when cross-domain requests
  timeout: define.timeout // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  if (config.url.indexOf('http') > -1) config.baseURL = '';
  // 部分接口timeout时间单独处理
  if (config.url.indexOf('SynThirdInfo') > -1 || config.url.indexOf('extend/Email/Receive') > -1 || config.url.indexOf('Permission/Authority/Data') > -1 || config.url.indexOf('DataSync/Actions/Execute') > -1) {}
  config.timeout = 10000000;
  // do something before request is sent
  if (store.getters.token) {
    config.headers['Authorization'] = getToken();
  }
  if (config.method == 'get') {
    config.params = config.data;
  }
  var timestamp = Date.parse(new Date()) / 1000;
  if (config.url.indexOf('?') > -1) {
    config.url += "&n=".concat(timestamp);
  } else {
    config.url += "?n=".concat(timestamp);
  }
  return config;
}, function (error) {
  // do something with request error
  if (process.env.NODE_ENV === 'development') {
    console.log(error); // for debug
  }
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  var config = response.config;
  var url = config.url;
  // 特殊接口处理
  if (url.indexOf('/Base/DataSource/Actions/Test') > -1 || url.indexOf('Model') > -1 && url.indexOf('Config') > -1) return res;
  // file
  if (config.headers['Content-Type'] && config.headers['Content-Type'].toLowerCase().indexOf('application/octet-stream') > -1) {
    return res;
  }
  if (res.code !== 200) {
    if (res.msg.toUpperCase().includes('ORA-12899')) {
      var str = res.msg;
      var startStr = str.substring(str.indexOf('ORA-12899:') + 11, str.indexOf('最大值'));
      var endStr = str.substring(str.indexOf('最大值'));
      var end = endStr.indexOf(')');
      var msg = startStr + endStr.substring(0, end + 1);
      res.msg = msg;
    }
    message({
      message: res.msg || '请求出错，请重试',
      type: 'error',
      showClose: true,
      duration: 0,
      onClose: function onClose() {
        if (url.indexOf('/api/oauth/Login') < 0 && url.indexOf('/api/oauth/LockScreen') < 0 && (res.code === 600 || res.code === 601 || res.code === 602)) {
          // 600：登录过期,请重新登录  601: 您的帐号在其他地方已登录,被强制踢出 602: Token验证失败
          store.dispatch('user/resetToken').then(function () {
            if (window.location.pathname.indexOf('login') > -1) return;
            setTimeout(function () {
              location.reload();
            }, 100);
          });
        }
      }
    });
    return Promise.reject(new Error(res.msg || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  if (process.env.NODE_ENV === 'development') {
    console.log(error); // for debug
  }
  message({
    message: '请求出错，请重试',
    type: 'error',
    showClose: true,
    duration: 0
  });
  return Promise.reject(error);
});
export default service;